import SetAssistants from "@forwardflow/components/Campaign/Assistants";

const Assistants = () => {
  return <SetAssistants />;
};

export default Assistants;
